import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import moment from "moment";
import uuid from "uuid";
import { Map, Set } from "immutable";
import styled from "styled-components";
import { Code } from "react-content-loader";
import Sidebar from "arui-feather/sidebar";
import Spin from "arui-feather/spin";
import axios from "axios";
import { Button } from "../../ui-kit/styled-templates";

export default function AnswerForm(props) {
    const {
        onSave = d => {

        }
    } = props;

    const [answer, setAnswer] = useState(props.answer);

    return (
        <Wrapper>

            <Row>
                <Textarea value={answer}
                          placeholder={"Ответ"}
                          onChange={evt => {
                              setAnswer(evt.target.value);
                          }}
                ></Textarea>
            </Row>

            <Row>
                <Button type="submit" background="blue" extra={`width: 100%; padding: `} onClick={() => {
                    onSave({
                        answer: answer
                    });
                }}>
                    Отправить
                </Button>
            </Row>

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const Row = styled.div`
  margin-bottom: 10px;
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;